<template>
  <div class="table__container">
    <el-table
        id="schedulesTable"
        :data="tableData"
        style="width: 100%;"
        max-height="485"
        :header-cell-class-name="headerCellClassName"
        :cell-class-name="cellClassName"
        :class="additionalClasses">
      <el-table-column
          prop="name"
          label="Name">
        <template slot-scope="scope">
          <schedules-table-cell
              :cell-data="scope.row"
              type="name" />
        </template>
      </el-table-column>

      <el-table-column
          prop="frequency"
          label="Frequency">
        <template slot-scope="scope">
          <schedules-table-cell
              :cell-data="scope.row"
              type="frequency" />
        </template>
      </el-table-column>

      <el-table-column
          prop="accessPeriod"
          label="Access Period">
        <template slot-scope="scope">
          <schedules-table-cell
              :cell-data="scope.row"
              type="accessPeriod" />
        </template>
      </el-table-column>

      <template slot="empty">
        <div class="no-records__container body__large-regular__secondary">
          {{ emptyMessage }}
        </div>
      </template>
    </el-table>
    <account-verification-message
        v-if="isAccountVerificationRequired"
        :device-name="deviceName" />
  </div>
</template>

<script>
import SchedulesTableCell from "./SchedulesTableCell";
import AccountVerificationMessage from "./AccountVerificationMessage";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("db/account");

export default {
  name: "SchedulesTable",
  components: {
    SchedulesTableCell,
    AccountVerificationMessage,
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    deviceName: {
      type: String,
      required: true,
    },
    emptyMessage: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["accountVerified"]),
    additionalClasses() {
      if (this.isAccountVerificationRequired) {
        return "blur";
      }

      return undefined;
    },
    isAccountVerificationRequired() {
      return !this.accountVerified;
    },
  },
  methods: {
    headerCellClassName(row, rowIndex) {
      return "new-ui__table-header__cell";
    },
    cellClassName(row, rowIndex) {
      return "new-ui__table-cell";
    },
  },
};
</script>

<style scoped>
.table__container {
  position: relative;
  width: 100%;
}
</style>

<style lang="scss">
@import "@/assets/scss/newui/tables.scss";

.new-ui__table-header__cell.is-leaf.el-table__cell {
  @include table-header__cell();
}

thead tr .new-ui__table-header__cell.el-table__cell .cell,
.new-ui__table-cell.el-table__cell .cell {
  @include table-cell();
}

#schedulesTable .el-table__empty-block {
  justify-content: left;
  text-align: left;
}

#schedulesTable .no-records__container {
  padding-left: 24px;
}

#schedulesTable.blur .el-table__body-wrapper.is-scrolling-none {
  filter: blur(9px);
}
</style>
